module.exports = __webpack_public_path__ + "static/media/stock.a32d15fe.png";